import * as requestFromServer from "./AttendanceCrud";
import { callTypes, attendanceSlice } from "./AttendanceSlice";

const {actions} = attendanceSlice;

export const getTeachersAndDailyCourseHour = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTeachersAndDailyCourseHour()
    .then(response => {
      dispatch(actions.teachersAndDailyCourseHourFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getSectionAttendances = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getSectionAttendances(queryParams)
    .then(response => {
      dispatch(actions.sectionsAttendancesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllSectionAttendances = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllSectionAttendances(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getAttendanceDetails = (sectionId, date, courseHour) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getAttendanceDetails(sectionId, date, courseHour)
    .then(response => {
      dispatch(actions.attendanceDetailsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getStudents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getStudents(queryParams)
    .then(response => {
      dispatch(actions.studentsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllStudents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllStudents(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getSections = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getSections()
    .then(response => {
      dispatch(actions.sectionsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getStudentAbsenteeisms = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getStudentAbsenteeisms(queryParams)
    .then(response => {
      dispatch(actions.studentAbsenteeismsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveAbsenteeisms = datas => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveAbsenteeisms(datas)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteAttendance = data => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteAttendance(data)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const deleteAttendances = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteAttendances(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanAttendanceState = () => dispatch => {
  return dispatch(actions.attendanceStateCleaned());
};